import React from "react";

import { FaBars } from "react-icons/fa";

const MobileNav = (props) => {
  return (
    <nav className="mobile-nav-container">
      <div className="mobile-nav-menu-container" onClick={props.toggleDrawer}>
        <FaBars />
      </div>
      <div className="mobile-nav-logo-container">
        <h3 className="mobile-nav-title">
          Deccan <span> Express</span>
        </h3>
      </div>
    </nav>
  );
};

export default MobileNav;
